import React from "react";
import { api } from "../lib/api";
import * as Phosphor from "@phosphor-icons/react";
import { motion } from "framer-motion";

export default function Amenities() {
  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    api.get("/amenities").then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  const renderIcon = (name) => {
    const Icon = Phosphor[name] || Phosphor.Sparkle;
    return <Icon size={28} weight="thin" />;
  };

  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="py-16 md:py-32 px-5 sm:px-6 md:px-12 lg:px-24 max-w-7xl mx-auto"
    >
      <div className="text-center mb-10 md:mb-16">
        <p className="overline mb-3 md:mb-4">Curated Comforts</p>
        <h2 className="font-serif-display text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tighter">
          Every Detail, <span className="italic text-[#C5A059]">Considered</span>
        </h2>
        <div className="gold-divider mx-auto mt-6 md:mt-8" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[var(--border)] border border-[var(--border)] rounded-2xl overflow-hidden">
        {items.map((a, i) => (
          <motion.div
            key={a.id}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.05 }}
            className="bg-[#0A0B10] p-5 sm:p-8 md:p-10 hover:bg-[#13151D] transition-colors group"
            data-testid={`amenity-${a.name.toLowerCase().replace(/\s/g, '-')}`}
          >
            <div className="text-[#C5A059] group-hover:scale-110 transition-transform">
              {renderIcon(a.icon)}
            </div>
            <h3 className="font-serif-display text-lg sm:text-xl md:text-2xl mt-4 sm:mt-6">{a.name}</h3>
            <p className="text-[#A1A4B5] text-xs sm:text-sm mt-1.5 sm:mt-2 leading-relaxed">{a.description}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
